import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ClassDirective } from '@ngbracket/ngx-layout';
import { HtmlSnackbarData } from './html-snackbar.model';

@Component({
    selector: 'dash-gis-html-snackbar',
    templateUrl: './html-snackbar.component.html',
    styleUrls: ['./html-snackbar.component.scss'],
    imports: [NgClass, ClassDirective, MatIconButton, MatIcon],
})
export class HtmlSnackbarComponent implements OnInit {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public snackData: HtmlSnackbarData,
        private snackBarRef: MatSnackBarRef<HtmlSnackbarComponent>
    ) {}

    ngOnInit(): void {}

    close() {
        this.snackBarRef.dismiss();
    }
}
